import {
  Box, Typography,
} from '@mui/material';
import { FC } from 'react';

import CloseButton from 'components/CloseButton';

interface DialogHeaderProps {
  title: string;
  onClose: () => void;
}

const DialogHeader: FC<DialogHeaderProps> = ({ title, onClose }) => (
  <Box display="flex" justifyContent="space-between" mb={2}>
    <Typography variant="h5" fontWeight={700}>{title}</Typography>
    <CloseButton onClose={onClose} />
  </Box>
);

export default DialogHeader;
